import { render, staticRenderFns } from "./provinces.vue?vue&type=template&id=fc9d161a&"
import script from "./provinces.vue?vue&type=script&lang=js&"
export * from "./provinces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports